import { useQuery } from '@zg-rentals/react-query5';
import { RentalManagerLeadManagementWebApiHandler_leadManagementTable } from '@zg-rentals/ts-rental-manager-api-beta-client';

import TimeConstants from '../../constants/TimeConstants';

export const useGetInterestedRenters = (
  { listingAlias = '', clientTimeZone = 'America/New_York', folder = 'inbox', limit = 3 },
  queryOptions = {},
) => {
  return useQuery({
    queryKey: ['getInterestedRenters', limit, listingAlias],
    queryFn: async () => {
      const data = await RentalManagerLeadManagementWebApiHandler_leadManagementTable({
        listingAlias,
        clientTimeZone,
        folder,
        limit,
      });

      return data;
    },
    ...queryOptions,
    enabled: Boolean(listingAlias),
    staleTime: TimeConstants.SECONDS_10,
  });
};
